const initialCurrency = {
  code: '',
  currency: '',
  name: '',
  country: '',
  computedPrice: null,
};

export default initialCurrency;
